// @ts-nocheck
import React from "react";

// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Form,
    Input,
    Container,
    Row,
    Col,
} from "reactstrap";
// core components
import Header from "components/Headers/ListingPageHeader.js";
import CategorySelectInput from "components/CategorySelectInput";
import Editor from "components/Editor";

class ProductListing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            category: "",
            tag: [],
            name: "",
            description: "",
            brand: "",
            price: 0,
            discount: 0,
            stock: 0,
            option: [],
            createAt: "",
            manufacturer: "",
            mfalink: "",
            modelname: "",
            validate: {
                nameState: "",
            },
        };
    }

    handleDoneListing = (e) => {
        //validation check
        if (this.validateFrom()) {
        }
    };

    validateFrom = () => {
        let validated = true;
        if (this.state.name == "") {
        }
        return validated;
    };

    render() {
        return (
            <div>
                <Header />
                <Container className="mt--7" fluid>
                    <Card className="bg-secondary shadow">
                        <CardHeader className="bg-white border-0">
                            <Row className="align-items-center">
                                <Col xs="8">
                                    <h3 className="mb-0">Add Product</h3>
                                </Col>
                                <Col className="text-right" xs="4">
                                    <Button
                                        color="primary"
                                        href="#pablo"
                                        onClick={(e) => e.preventDefault()}
                                        size="sm"
                                    >
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Form>
                                <h6 className="heading-small text-muted mb-4">
                                    CATEGORY
                                </h6>
                                <div className="pl-lg-4">
                                    <CategorySelectInput />
                                </div>

                                <hr className="my-4" />
                                <div className="pl-lg-4">
                                    <Row>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="Product Name"
                                                >
                                                    PRODUCT NAME
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-productname"
                                                    placeholder="ProductName"
                                                    type="text"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="6">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label"
                                                    htmlFor="input"
                                                >
                                                    Brand
                                                </label>
                                                <Input
                                                    className="form-control-alternative"
                                                    id="input-email"
                                                    placeholder="Nike"
                                                    type="email"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </div>
                                <hr className="my-4" />
                                <h6 className="heading-small text-muted mb-4">
                                    Description
                                </h6>
                                <div className="pl-lg-4">
                                    <FormGroup>
                                        <label>Description</label>
                                        <Editor />
                                    </FormGroup>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        );
    }
}

export default ProductListing;
